import DarkModeIcon from "@mui/icons-material/DarkMode";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import { useTheme } from "@mui/material";

import { IconMenuItem } from "@/Components/v2/atoms/MenuItem";
import { Stack } from "@/Components/v2/atoms/Stack";
import { AppleSwitch } from "@/Components/v2/atoms/Switch";
import { Typography } from "@/Components/v2/atoms/Typography";
import { useInfo } from "@/context/InfoProvider/InfoProvider";

export const ThemeToggle = () => {
  const theme = useTheme();

  const { theme: colorTheme, changeTheme } = useInfo();

  const triggerThemeUpdate = () => {
    changeTheme();
  };

  const handleItemClick = () => {
    triggerThemeUpdate();
  };

  const handleSwitchChange = (event) => {
    event.stopPropagation();
    triggerThemeUpdate();
  };

  const isDarkMode = colorTheme.mode === "dark";

  const icon = isDarkMode ? (
    <WbSunnyIcon sx={{ color: theme.palette.brandedTypography.textColor }} />
  ) : (
    <DarkModeIcon sx={{ color: theme.palette.brandedTypography.textColor }} />
  );

  return (
    <IconMenuItem icon={icon} onClick={handleItemClick}>
      <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center">
        <Typography variant="body2">{isDarkMode ? "Light" : "Dark"} Mode</Typography>
        <AppleSwitch
          checked={isDarkMode}
          onChange={handleSwitchChange}
          onClick={(e) => e.stopPropagation()}
        />
      </Stack>
    </IconMenuItem>
  );
};

export default ThemeToggle;
